export const COMMAND_PALETTE_SHORTCUT = "meta+k, ctrl+k";
export const ENTER_KEY = "Enter";

export const KEY_LABEL = {
  UP: "↑",
  DOWN: "↓",
  ENTER: "↵",
  BACKSPACE: "⌫",
  MAC_MODIFIER: "⌘",
  MODIFIER: "Ctrl",
} as const;

export const QUICK_NAV_OPEN_SOURCE = {
  SHORTCUT: "SHORTCUT",
  SIDEBAR: "SIDEBAR",
} as const;

export type QuickNavOpenSource =
  (typeof QUICK_NAV_OPEN_SOURCE)[keyof typeof QUICK_NAV_OPEN_SOURCE];
